import classNames from 'classnames';

type Props = {
  onClick?: () => void;
};

export const StethoscopeIcon = ({ onClick }: Props) => {
  return (
    <svg
      className={classNames(onClick ? 'cursor-pointer' : '')}
      onClick={onClick ? onClick : undefined}
      width="15"
      height="20"
      viewBox="0 0 56 64"
      fill="#000000"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M10.0188 32.2701H19.5066V28.0962H8.60152L8.91679 29.619C9.11533 30.5779 9.4978 31.4726 10.0188 32.2701Z"
        fill="#BACFD4"
      />
      <path
        d="M28.9306 32.2701C29.4516 31.4726 29.8341 30.5779 30.0326 29.619L30.3479 28.0962H19.5064V32.2701H28.9306Z"
        fill="#BACFD4"
      />
      <path
        d="M45.5256 29.7648V46.8165C45.5256 53.2227 40.3137 58.4347 33.9074 58.4347C27.5011 58.4347 22.2892 53.2227 22.2892 46.8165V41.4608H22.3964C25.506 41.4608 28.5463 40.3361 30.9576 38.2938C33.2739 36.3317 34.8809 33.6517 35.4822 30.7473L37.0053 23.3919L36.324 23.2508L32.2367 22.4045L31.5555 22.2634L30.3477 28.0961L30.0325 29.6188C29.8339 30.5777 29.4515 31.4725 28.9304 32.27C27.5074 34.4486 25.041 35.8956 22.3966 35.8956H19.5067V41.4608H16.7241V46.8165C16.724 56.2914 24.4323 63.9999 33.9074 63.9999C43.3825 63.9999 51.0908 56.2914 51.0908 46.8165V29.7345C50.2296 30.1164 49.2774 30.3303 48.2748 30.3303C47.2981 30.3303 46.369 30.1282 45.5256 29.7648Z"
        fill="#3D3D3D"
      />
      <path
        d="M55.2312 23.374C55.2312 19.5326 52.1161 16.4175 48.2747 16.4175V20.5914C49.809 20.5914 51.0573 21.8397 51.0573 23.374C51.0573 24.9083 49.809 26.1566 48.2747 26.1566V30.3305C49.2773 30.3305 50.2296 30.1167 51.0907 29.7346C53.5291 28.6533 55.2312 26.2128 55.2312 23.374Z"
        fill="#DD0C26"
      />
      <path
        d="M48.2747 26.1566C46.7404 26.1566 45.4921 24.9083 45.4921 23.374C45.4921 21.8397 46.7404 20.5914 48.2747 20.5914V16.4175C44.4333 16.4175 41.3182 19.5326 41.3182 23.374C41.3182 26.2388 43.0512 28.6989 45.5255 29.765C46.3689 30.1284 47.298 30.3305 48.2747 30.3305V26.1566Z"
        fill="#DD0C26"
      />
      <path
        d="M4.30865 10.7948C3.97376 9.17736 4.28319 7.67976 5.1803 6.57799C6.07742 5.47622 7.48096 4.86947 9.13272 4.86947H10.9879V0.695557H9.13272C6.20152 0.695557 3.64834 1.84881 1.94343 3.94286C0.238669 6.03691 -0.372948 8.77083 0.221417 11.6411L2.62531 23.2507L6.71255 22.4044L4.30865 10.7948Z"
        fill="#BACFD4"
      />
      <path
        d="M38.7281 11.6411C39.3223 8.77069 38.7107 6.03677 37.006 3.94272C35.3012 1.84881 32.7479 0.695557 29.8168 0.695557H27.9618V4.86947H29.8168C31.4686 4.86947 32.8723 5.47622 33.7692 6.57813C34.6662 7.68004 34.9759 9.1775 34.641 10.7949L32.237 22.4045L36.3242 23.2508L38.7281 11.6411Z"
        fill="#BACFD4"
      />
      <path
        d="M19.5066 35.8957H16.553C13.9085 35.8957 11.4421 34.4487 10.0187 32.2701C9.49766 31.4726 9.11519 30.5779 8.91665 29.619L8.60138 28.0962L7.39359 22.2634L6.7124 22.4045L2.62517 23.2508L1.94385 23.3919L3.46691 30.7475C4.06837 33.6518 5.67533 36.3319 7.99171 38.2939C10.4031 40.3362 13.4435 41.4609 16.5531 41.4609H19.5067L19.5066 35.8957Z"
        fill="#3D3D3D"
      />
      <path
        d="M45.4921 23.3739C45.4921 24.9082 46.7404 26.1565 48.2747 26.1565C49.809 26.1565 51.0573 24.9082 51.0573 23.3739C51.0573 21.8396 49.809 20.5913 48.2747 20.5913C46.7404 20.5913 45.4921 21.8396 45.4921 23.3739Z"
        fill="white"
      />
      <path
        d="M16.553 0H10.9877V5.56522H16.553V0Z"
        fill="black"
        fillOpacity="0.75"
      />
      <path
        d="M27.9617 0H22.3964V5.56522H27.9617V0Z"
        fill="black"
        fillOpacity="0.75"
      />
    </svg>
  );
};
